import { Route, Routes } from "react-router-dom";

import { AuthGuard } from "./components/AuthGuard";
import { AcceptInvitationPage } from "./pages/AcceptInvitationPage";
import { ApiKeysPage } from "./pages/ApiKeysPage";
import { BrandKitsPage } from "./pages/BrandKitsPage";
import { DashboardPage } from "./pages/DashboardPage";
import { EditorPage } from "./pages/EditorPage";
import { HomePage } from "./pages/HomePage";
import { ImportsPage } from "./pages/ImportsPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { SettingsPage } from "./pages/SettingsPage";
import { TeamPage } from "./pages/TeamPage";
import { TemplatesPage } from "./pages/TemplatesPage";
import { WebhooksPage } from "./pages/WebhooksPage";
import { ForgotPasswordPage } from "./pages/auth/ForgotPasswordPage";
import { LoginPage } from "./pages/auth/LoginPage";
import { ResetPasswordPage } from "./pages/auth/ResetPasswordPage";
import { SignupPage } from "./pages/auth/SignupPage";
import { VerifyEmailPage } from "./pages/auth/VerifyEmailPage";

export function App(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup" element={<SignupPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
      <Route
        path="/dashboard"
        element={
          <AuthGuard>
            <DashboardPage />
          </AuthGuard>
        }
      />
      <Route
        path="/templates"
        element={
          <AuthGuard>
            <TemplatesPage />
          </AuthGuard>
        }
      />
      <Route
        path="/templates/:id/edit"
        element={
          <AuthGuard>
            <EditorPage />
          </AuthGuard>
        }
      />
      <Route
        path="/brand-kit"
        element={
          <AuthGuard>
            <BrandKitsPage />
          </AuthGuard>
        }
      />
      <Route
        path="/api-keys"
        element={
          <AuthGuard>
            <ApiKeysPage />
          </AuthGuard>
        }
      />
      <Route
        path="/webhooks"
        element={
          <AuthGuard>
            <WebhooksPage />
          </AuthGuard>
        }
      />
      <Route
        path="/imports"
        element={
          <AuthGuard>
            <ImportsPage />
          </AuthGuard>
        }
      />
      <Route
        path="/settings"
        element={
          <AuthGuard>
            <SettingsPage />
          </AuthGuard>
        }
      />
      <Route
        path="/team"
        element={
          <AuthGuard>
            <TeamPage />
          </AuthGuard>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
